import React from 'react'
import styled from 'styled-components'
import Fade from 'react-reveal/Fade'

const Footer2 = () => {

    return (
        <>
		{/* style={{ backgroundImage: `url(${learn})` }} */}
         <Wrap >
			{/* <img className='img' src={learn} /> */}
         <Fade bottom>
            <ItemText>
                <p>© 2022 Captivators, MJPRU, Bareilly - All Rights Reserved.</p>
                <p>Department Of CSIT, 
Mahatma Jyotiba Phule Rohilkhand University,
Bareilly, Uttar Pradesh Pincode:-243006</p>
				</ItemText>
			</Fade>
            
         </Wrap>
         
        </>
    );

}

export default Footer2;


const Wrap = styled.div `
    color:white;
    background-color:green;
    min-width:100vw;
	background-size: cover; /* set size to cover */
	background-position: center; /* center the image */
	background-repeat: no-repeat; /* dont repeat the background */

	display: flex;
	flex-direction: column; /* switch to vertical */
	justify-content: center; /* horizontal alignment */
	align-items: center; /* vertical alignment */

	@media (max-width : 768px){
		flex-direction: column;
	}
`

const ItemText = styled.div `
	text-align: center;
`
